import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "insert-modal-content" }
const _hoisted_2 = { class: "field" }

import { ref } from 'vue'; // defineEmits 임포트
import axios from '../../api/notice';
import Swal from 'sweetalert2';

// emit 함수 정의 (부모 컴포넌트에 이벤트를 보낼 때 사용)

export default /*@__PURE__*/_defineComponent({
  __name: 'insertNotice',
  emits: ['close', 'noticeAdded'],
  setup(__props, { emit: __emit }) {

const emits = __emit; // 'close'와 'noticeAdded' 이벤트 정의

const form = ref({
  title: '',
  content: '',
});

const submit = async () => {
  try {
    const res = await axios.insertNotice({
      title: form.value.title,
      content: form.value.content,
    });
    console.log('성공:', res.data);
    await Swal.fire({
      icon: 'success',
      title: '등록 성공',
      text: '공지사항이 성공적으로 등록되었습니다!',
      confirmButtonText: '확인',
    });
    
    // 성공적으로 등록되면 부모에게 알리고 모달을 닫음
    emits('noticeAdded'); // 공지사항이 추가되었음을 부모에게 알림
    emits('close'); // 모달 닫기 요청
    
  } catch (err) {
    console.error('에러 발생:', err);
    Swal.fire({
      icon: 'error',
      title: '등록 실패',
      text: '공지사항 등록 중 오류가 발생했습니다.',
      confirmButtonText: '확인',
    });
  }
};

// 모달 닫기 함수
const closeModal = () => {
  emits('close'); // 'close' 이벤트를 부모 컴포넌트로 보냄
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "insert-modal-overlay",
    onClick: _withModifiers(closeModal, ["self"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[4] || (_cache[4] = _createElementVNode("h3", null, "새 공지사항 등록", -1)),
      _createElementVNode("div", _hoisted_2, [
        _cache[2] || (_cache[2] = _createElementVNode("label", { for: "title" }, "제목:", -1)),
        _withDirectives(_createElementVNode("input", {
          id: "title",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.title) = $event)),
          type: "text"
        }, null, 512), [
          [_vModelText, form.value.title]
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("label", { for: "content" }, "내용:", -1)),
        _withDirectives(_createElementVNode("textarea", {
          id: "content",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.content) = $event))
        }, null, 512), [
          [_vModelText, form.value.content]
        ]),
        _createElementVNode("div", { class: "insert-modal-buttons" }, [
          _createElementVNode("button", {
            class: "submit-btn",
            onClick: submit
          }, " 등록 "),
          _createElementVNode("button", {
            class: "cancel-btn",
            onClick: closeModal
          }, " 취소 ")
        ])
      ])
    ])
  ]))
}
}

})